import {
  MODULE_FIND_ALL,
  MODULE_SET_INITIAL_STATE,
  MODULE_VIEW
} from './moduleTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODULE_SET_INITIAL_STATE:
      return initialState;
    case MODULE_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case MODULE_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
